export const kBoxPlotClass = "box-plot"
export const kBoxPlotType = "Box Plot"
export const kBoxPlotPrefix = "ADRN"
export const kBoxPlotLabelKey = "Box Plot"
export const kBoxPlotUndoAddKey = "DG.Undo.graph.showPlottedBoxPlot"
export const kBoxPlotRedoAddKey = "DG.Redo.graph.showPlottedBoxPlot"
export const kBoxPlotUndoRemoveKey = "DG.Undo.graph.hidePlottedBoxPlot"
export const kBoxPlotRedoRemoveKey = "DG.Redo.graph.hidePlottedBoxPlot"
export const kBoxPlotValueTitleKey = "DG.PlottedAverageAdornment.boxPlotTitle"
